import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { APIProvider } from '@vis.gl/react-google-maps';

import { router } from './App';
import reportWebVitals from './reportWebVitals';
import { createTheme } from './theme';

import 'react-toastify/dist/ReactToastify.css';

import { GOOGLE_API_KEY } from '~configs';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: process.env.NODE_ENV === 'production',
      refetchOnReconnect: process.env.NODE_ENV === 'production',
      refetchOnMount: false,
      retry: false,
      staleTime: 1000 * 60 * 2,
      keepPreviousData: true,
    },
  },
});

const theme = createTheme();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <LocalizationProvider dateAdapter={AdapterDateFns}>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ToastContainer />
        <APIProvider
          apiKey={GOOGLE_API_KEY || ''}
          onLoad={() => {
            // eslint-disable-next-line no-console
            console.log('Maps API has loaded.');
          }}
        >
          <RouterProvider router={router} />
        </APIProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </LocalizationProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
